import {
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
  type Announcements,
  type DndContextProps,
  type UniqueIdentifier,
} from '@dnd-kit/core'
import { sortableKeyboardCoordinates } from '@dnd-kit/sortable'

const POINTER_ACTIVATION_DISTANCE_PX = 4

/** Pointer and keyboard sensors plus announcements that name items by label instead of their local keys. */
export function useSortableList(
  labelFor: (id: UniqueIdentifier) => string,
): Pick<DndContextProps, 'sensors' | 'accessibility'> {
  const sensors = useSensors(
    useSensor(PointerSensor, { activationConstraint: { distance: POINTER_ACTIVATION_DISTANCE_PX } }),
    useSensor(KeyboardSensor, { coordinateGetter: sortableKeyboardCoordinates }),
  )
  return { sensors, accessibility: { announcements: buildAnnouncements(labelFor) } }
}

function buildAnnouncements(labelFor: (id: UniqueIdentifier) => string): Announcements {
  return {
    onDragStart: ({ active }) => `Picked up ${labelFor(active.id)}.`,
    onDragOver: ({ active, over }) => (over ? `${labelFor(active.id)} moved to ${labelFor(over.id)}.` : undefined),
    onDragEnd: ({ active, over }) =>
      over ? `${labelFor(active.id)} dropped at ${labelFor(over.id)}.` : `${labelFor(active.id)} dropped.`,
    onDragCancel: ({ active }) => `Reordering cancelled. ${labelFor(active.id)} dropped.`,
  }
}
